import styles from "./WelcomeDashboard.module.css";

import WelcomeHero from "./components/WelcomeHero";
import TrialStatusCard from "./components/TrialStatusCard";
import GettingStartedCard from "./components/GettingStartedCard";
import ProFeaturesCard from "./components/ProFeaturesCard";
import { useSelector } from "react-redux";
import { getSubscriptionInfo } from "../../services/functions";
import { useNavigate } from "react-router-dom";

const WelcomeDashboard = () => {

    const navigate = useNavigate();

    const user = useSelector(
        state => state.user.user
    );

    const subscription = getSubscriptionInfo(

        user
    
    );

    return (

        <div className={styles.container}>

            <WelcomeHero user={user}/>

            <TrialStatusCard
                plan={subscription.plan}
                remainingDays={subscription.remainingDays}
                expireDate={user.expireDateP}
                onUpgrade={() => navigate("/subscription")}
            />

            <GettingStartedCard />

            <ProFeaturesCard />

        </div>

    );

};

export default WelcomeDashboard;